module.exports = __webpack_public_path__ + "img/duke.435c1f52.png";